import * as actions from '../actions'

export const initialState = {
  status: undefined,
  existingServices: undefined,
  details: undefined,
  isSubmitted: false,
  projectCodes: undefined,
  moveDetails: undefined,
  cbmStandaloneOrderFlowEnabled: false,
  showMoveModal: false,
  cbmLaunchStatus: {
    isSuccess: false
  },
  cbmLaunchLoading: false
}

function orderReducer(state = initialState, { type, payload } = {}) {
  switch (type) {
    case actions.SUBMIT_ORDER_SUCCESS:
    case actions.SET_ORDER_IS_SUBMITTED: {
      const { isSubmitted = true } = payload || {}

      return { ...state, isSubmitted }
    }

    case actions.SET_EXISTING_SERVICES: {
      const { existingServices } = payload

      return {
        ...state,
        existingServices
      }
    }

    case actions.SET_ORDER_STATUS: {
      const { status } = payload

      return {
        ...state,
        status
      }
    }

    case actions.SET_DOCUMENT_TYPES: {
      return {
        ...state,
        documentTypes: payload
      }
    }

    case actions.SET_ORDER_DETAILS: {
      return {
        ...state,
        details: payload
      }
    }

    case actions.UPDATE_ORDER: {
      return {
        ...state,
        ...payload
      }
    }

    case actions.TOGGLE_MOVE_MODAL: {
      return {
        ...state,
        showMoveModal: !state.showMoveModal
      }
    }

    case actions.SET_LAUNCH_CBM_BUTTON_REF: {
      const { launchCbmButtonRef } = payload
      return {
        ...state,
        launchCbmButtonRef
      }
    }

    case actions.SET_CBM_LAUNCH_STATUS: {
      const { isSuccess } = payload
      return {
        ...state,
        cbmLaunchStatus: {
          isSuccess
        }
      }
    }

    case actions.SET_CBM_LAUNCH_LOADING: {
      const { isLoading } = payload
      return {
        ...state,
        cbmLaunchLoading: isLoading
      }
    }

    default: {
      return state
    }
  }
}
export default orderReducer
